import React from 'react';
import { Link } from 'react-router';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

import Row from '../components/row';
import Title from '../components/title';

const Room = ({ title, images, children}) => {
  return (
    <Row>
      <Title title={title} />
      <div className="col-xs-5 col-xs-offset-1">
        <ImageGallery
          items={images}
          slideInterval={2000} />
      </div>
      <div className="mt30 col-xs-6 ">
        {children}
        <div className="form-group col-xs-12 mt30">
          <Link to="/book"><button className="btn btn-info">Reservar<span className="glyphicon glyphicon-pencil"></span></button></Link>
        </div>
      </div>
    </Row>
  );
};

export default Room;

// const Capacity = ({capacity}) => {
//   const times = Array.apply(null, Array(capacity));
//   const template = times.map((v, k) => (<i key={k} className="glyphicon glyphicon-user"></i>))
//   return <span>{template}</span>
// }

// <p className="p-services">Capacidad &nbsp;
//   <Capacity capacity={capacity} />
// </p>



// WEBPACK FOOTER //
// ./src/rooms/room.js